<template>
  <!-- 数据统计-取回/商城统计 -->
  <div class="retrieve_or_shop_statistic-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item>
          <el-input
            size="small"
            v-model="query.user_id"
            placeholder="用户UID"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            style="width: 200px"
            v-model="query.start_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
          ——
          <el-date-picker
            style="width: 200px"
            v-model="query.end_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.type">
            <el-option :value="1" label="取回"></el-option>
            <el-option :value="3" label="商城"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            class="add-btn"
            style="margin-right: 20px"
            @click="getData"
            >查询
          </el-button>
        </el-form-item>
      </el-form>
    </header>
    <p class="prompt">默认展示当天数据</p>
    <!-- body内容 -->
    <div class="body-box">
      <el-table :data="dataList" v-loading="loading">
        <el-table-column prop="web_price" label="IG成功发货金额(网站成本)">
          <template slot-scope="{ row }">
            <span>{{ row.web_price ? row.web_price : 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="user_price" label="IG成功发货金额(用户成本)">
          <template slot-scope="{ row }">
            <span>{{ row.user_price ? row.user_price : 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="利润">
          <template slot-scope="{ row }">
            <span>{{ (row.user_price - row.web_price).toFixed(2) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :total="dataMeta ? dataMeta.total : 0"
        :current-page="dataMeta ? dataMeta.current_page : 1"
        :page-size="dataMeta ? dataMeta.per_page : 15"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
  </div>
</template>

<script>
import {
  mapState,
  mapMutations,
  mapActions
} from 'vuex'
import {
  api,
  getData,
  delApiData,
  getApiData,
  postApiData,
  patchApiData
} from '../../http'
export default {
  name: 'retrieve_or_shop_statistic',
  components: {},
  data() {
    return {
      loading: false, //页面数据加载动画
      buttonLoading: false, //按钮加载动画
      dialogLoading: false, //弹窗加载数据动画
      query: { //页面查询条件
        user_id: '',
        type: 1,
        start_time: '',
        end_time: ''
      },
      dataList: undefined,//数据列表
      dataMeta: undefined, //底部跳转页面条
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
    }
  },
  computed: {
    ...mapState({})
  },
  watch: {},
  created() {
    this.getData()
  },
  mounted() { },
  methods: {
    ...mapMutations(['']),
    ...mapActions(['']),
    getData() {
      let params = this.query
      getApiData('ig_order_statistics', params).then((res) => {
        if (res) {
          let arr = []
          arr.push(res)
          this.dataList = arr
        }
      })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
  },
}

</script>

<style lang="less" scoped>
.retrieve_or_shop_statistic-box {
  header {
  }

  .body-box {
  }
}
</style>


